Date.locale = {
    en: {
        monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
    },
    sv: {
        monthNames: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
        monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
        dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
        dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
        dayNamesMin: ['S', 'M', 'T', 'O', 'T', 'F', 'L']
    }
};
Date.getLocalized = function (lang) {
    lang = lang && (lang in Date.locale) ? lang : 'sv';
    return Date.locale[lang];
};
Date.prototype.getMonthName = function (lang) {
    lang = lang && (lang in Date.locale) ? lang : 'sv';
    return Date.locale[lang].monthNames[this.getMonth()];
};
Date.prototype.getMonthNameShort = function (lang) {
    lang = lang && (lang in Date.locale) ? lang : 'sv';
    return Date.locale[lang].monthNamesShort[this.getMonth()];
};
Date.prototype.getDayName = function (lang) {
    lang = lang && (lang in Date.locale) ? lang : 'sv';
    return Date.locale[lang].dayNames[this.getDay()];
};
Date.prototype.getDayNameShort = function (lang) {
    lang = lang && (lang in Date.locale) ? lang : 'sv';
    return Date.locale[lang].dayNamesShort[this.getDay()];
};
Date.prototype.daysAgo = function (date) {
    function daydiff(first, second) {
        return (second.getTime() - first.getTime()) / (1000 * 60 * 60 * 24);
    }
    var diff = 0;
    if (date) {
        diff = daydiff(this, date);
    }
    else {
        diff = daydiff(this, new Date());
    }
    return diff;
};
Date.prototype.toFormat = function (format, lang) {
    var _this = this;
    var formats = ["yyyy", "yy", "MMMM", "MMM", "MM", "M", "dddd", "ddd", "dd", "d", "hh", "h", "HH", "H", "mm", "m", "ss", "s", "ffff", "fff", "ff", "f", "FFFF", "FFF", "FF", "F", "tt", "t"];
    var pad = function (val) {
        return (val > 9 ? '' : '0') + val;
    };
    var fill = function (val, length) {
        if (val.length < length) {
            return (Number(val) * ((length + 1) - val.length)).toString();
        }
        return val;
    };
    function fixFormat(format) {
        var tmpFormat = format;
        var parts = [];
        lengthLoop: while (tmpFormat.length > 0) {
            formatLoop: for (var i_1 = 0; i_1 < formats.length; i_1++) {
                if (tmpFormat.indexOf(formats[i_1]) === 0) {
                    parts.push(formats[i_1]);
                    tmpFormat = tmpFormat.substring(formats[i_1].length);
                    break formatLoop;
                }
            }
            parts.push(tmpFormat.substring(0, 1));
            tmpFormat = tmpFormat.substring(1);
        }
        return parts;
    }
    function formater(format) {
        switch (format) {
            case "yyyy":
                return _this.getFullYear();
            case "yy":
                return (_this.getFullYear().toString()).substr(2, 2);
            case "MMMM":
                return _this.getMonthName(lang);
            case "MMM":
                return _this.getMonthNameShort(lang);
            case "MM":
                return pad(_this.getMonth() + 1);
            case "M":
                return _this.getMonth() + 1;
            case "dddd":
                return _this.getDayName(lang);
            case "ddd":
                return _this.getDayNameShort(lang);
            case "dd":
                return pad(_this.getDate());
            case "d":
                return _this.getDate();
            case "hh":
                return pad((_this.getHours() % 12 ? _this.getHours() % 12 : 12));
            case "h":
                return _this.getHours() % 12 ? _this.getHours() % 12 : 12;
            case "HH":
                return pad(_this.getHours());
            case "H":
                return _this.getHours();
            case "mm":
                return pad(_this.getMinutes());
            case "m":
                return _this.getMinutes();
            case "ss":
                return pad(_this.getSeconds());
            case "s":
                return _this.getSeconds();
            case "ffff":
                return fill(_this.getMilliseconds().toString().substr(0, 4), 4);
            case "fff":
                return fill(_this.getMilliseconds().toString().substr(0, 3), 3);
            case "ff":
                return fill(_this.getMilliseconds().toString().substr(0, 2), 2);
            case "f":
                return _this.getMilliseconds().toString().substr(0, 1);
            case "FFFF":
                return _this.getMilliseconds().toString().substr(0, 4);
            case "FFF":
                return _this.getMilliseconds().toString().substr(0, 3);
            case "FF":
                return _this.getMilliseconds().toString().substr(0, 2);
            case "F":
                return _this.getMilliseconds().toString().substr(0, 1);
            case "tt":
                return (_this.getHours() < 12 ? 'AM' : 'PM');
            case "t":
                return (_this.getHours() < 12 ? 'A' : 'P');
        }
        return format;
    }
    var formatList = fixFormat(format);
    var formated = "";
    for (var i = 0; i < formatList.length; i++) {
        formated += formater(formatList[i]).toString();
    }
    return formated;
};
Date.today = function () {
    var d = new Date();
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);
    return d;
};
Date.prototype.addDays = function (n) {
    this.setDate(this.getDate() + n);
    this.tempDate = this.getDate();
    return this;
};
Date.prototype.addMonths = function (n) {
    if (this.tempDate == null) {
        this.tempDate = this.getDate();
    }
    this.setDate(1);
    this.setMonth(this.getMonth() + n);
    this.setDate(Math.min(this.tempDate, this.getMaxDays()));
    return this;
};
Date.prototype.addYears = function (n) {
    if (this.tempDate == null) {
        this.tempDate = this.getDate();
    }
    this.setDate(1);
    this.setFullYear(this.getFullYear() + n);
    this.setDate(Math.min(this.tempDate, this.getMaxDays()));
    return this;
};
Date.prototype.addHours = function (n) {
    return this.addMilliseconds(n * 3600000);
};
Date.prototype.addMinutes = function (n) {
    return this.addMilliseconds(n * 60000);
};
Date.prototype.addSeconds = function (n) {
    return this.addMilliseconds(n * 1000);
};
Date.prototype.addMilliseconds = function (n) {
    if (this.tempDate == null) {
        this.tempDate = this.getDate();
    }
    this.setTime(this.getTime() + (n));
    this.tempDate = this.getDate();
    return this;
};
Date.prototype.getMaxDays = function () {
    var tmpDate = new Date(Date.parse(this)), d = 28, m;
    m = tmpDate.getMonth();
    d = 28;
    while (tmpDate.getMonth() == m) {
        d++;
        tmpDate.setDate(d);
    }
    return d - 1;
};
Date.prototype.getFirstDay = function () {
    var tmpDate = new Date(Date.parse(this));
    tmpDate.setDate(1);
    return tmpDate.getDay();
};
Date.prototype.getWeekNumber = function () {
    var tempDate = new Date(this);
    tempDate.setDate(tempDate.getDate() - (tempDate.getDay() + 6) % 7 + 3);
    var dms = tempDate.valueOf();
    tempDate.setMonth(0);
    tempDate.setDate(4);
    return Math.round((dms - tempDate.valueOf()) / (604800000)) + 1;
};
Date.prototype.getDayOfYear = function () {
    var now = new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0);
    var then = new Date(this.getFullYear(), 0, 0, 0, 0, 0);
    var time = now.getTime() - then.getTime();
    return Math.floor(time / 24 * 60 * 60 * 1000);
};
Date.parseISO = function (s) {
    var date = s.substring(0, 10).split("-");
    var time = s.substring(11, 19).split(":");
    var year = parseInt(date[0], 10);
    year = (year) ? year : 1;
    var month = parseInt(date[1], 10) - 1;
    month = (month != undefined && month != null && !isNaN(month)) ? month : 0;
    var day = parseInt(date[2], 10);
    day = (day) ? day : 1;
    var hour = parseInt(time[0], 10);
    hour = (hour) ? hour : 0;
    var minute = parseInt(time[1], 10);
    minute = (minute) ? minute : 0;
    var second = parseInt(time[2], 10);
    second = (second) ? second : 0;
    var d = new Date(year, month, day, hour, minute, second);
    return d;
};
Date.parseISO8601 = function (s) {
    var day, tz, rx = /^(\d{4}\-\d\d\-\d\d([tT][\d:\.]*)?)([zZ]|([+\-])(\d\d):(\d\d))?$/, p = rx.exec(s) || [];
    if (p[1]) {
        day = p[1].split(/\D/).map(function (itm) {
            return parseInt(itm, 10) || 0;
        });
        day[1] -= 1;
        day = new Date(Date.UTC.apply(Date, day));
        if (!day.getDate())
            return NaN;
        if (p[5]) {
            tz = parseInt(p[5], 10) * 60;
            if (p[6])
                tz += parseInt(p[6], 10);
            if (p[4] == "+")
                tz *= -1;
            if (tz)
                day.setUTCMinutes(day.getUTCMinutes() + tz);
        }
        return day;
    }
    return NaN;
};
